import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ItemForm, type ItemFormRef } from './ItemForm';
import type { ApiItem } from '@/lib/api/types';
import type { Item } from '@/lib/api';
import { useRef, useEffect } from 'react';
import { useUpdateItem } from '@/lib/hooks/useItems';
interface EditItemDialogProps {
  isOpen: boolean;
  onClose: () => void;
  item: Item | ApiItem;
}
export function EditItemDialog(t0) {
  const $ = _c(30);
  const {
    isOpen,
    onClose,
    item
  } = t0;
  const formRef = useRef(null);
  const updateItemMutation = useUpdateItem();
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (!isOpen) {
        const timer = setTimeout(_temp, 100);
        return () => clearTimeout(timer);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== item) {
    t3 = "handle" in item ? item as ApiItem : {
      id: Number(item.id),
      type: "product",
      key: "",
      parentId: null,
      siteId: 0,
      brandId: item.brand?.id || 0,
      title: item.title,
      handle: "",
      description: item.description || "",
      price_1: item.price_1?.toString() || "0",
      price_2: item.price_2?.toString() || "0",
      image: item.image,
      status: item.status,
      visibility: item.visibility,
      brand: item.brand,
      tags: item.tags || [],
      data: item.data || {},
      available: true,
      availableLastAt: null,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
      site: {} as any,
      url: item.url,
      userCollections: item.userCollections,
      engagement: item.engagement,
      userReactions: item.userReactions,
      brandPermissions: item.brandPermissions,
      following: item.following
    };
    $[3] = item;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const apiItem = t3;
  let t4;
  if ($[5] !== apiItem || $[6] !== onClose || $[7] !== updateItemMutation) {
    t4 = data => {
      const tags = data.tags ? data.tags.split(",").map(_temp2).filter(Boolean) : [];
      const price_1 = data.price_1 ? parseFloat(data.price_1) : undefined;
      const price_2 = data.price_2 ? parseFloat(data.price_2) : undefined;
      const existingData = apiItem.data as Record<string, unknown> || {};
      const updatedData = {
        ...existingData,
        url: data.url || undefined,
        ...(data.galleryImages && {
          gallery: {
            images: data.galleryImages
          }
        }),
        country_origin: data.country_origin || undefined,
        country_manufactured: data.country_manufactured || undefined,
        countries_ingredients: data.countries_ingredients || undefined
      };
      updateItemMutation.mutate({
        id: Number(apiItem.id),
        data: {
          title: data.title,
          handle: data.handle,
          description: data.description,
          brandId: data.brandId,
          image: data.image,
          price_1: price_1?.toString(),
          price_2: price_2?.toString(),
          status: data.status,
          available: data.available,
          tags,
          data: updatedData
        },
        item: apiItem
      }, {
        onSuccess: () => {
          onClose();
        }
      });
    };
    $[5] = apiItem;
    $[6] = onClose;
    $[7] = updateItemMutation;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleSubmit = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogHeader><DialogTitle>Edit Product</DialogTitle><DialogDescription>Update product information</DialogDescription></DialogHeader>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== apiItem || $[11] !== handleSubmit) {
    t6 = <div className="flex-1 overflow-y-auto -mx-6 px-6"><ItemForm ref={formRef} item={apiItem} onSubmit={handleSubmit} /></div>;
    $[10] = apiItem;
    $[11] = handleSubmit;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClose || $[14] !== updateItemMutation.isPending) {
    t7 = <Button type="button" variant="outline" onClick={onClose} disabled={updateItemMutation.isPending}>Cancel</Button>;
    $[13] = onClose;
    $[14] = updateItemMutation.isPending;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => formRef.current?.submit();
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = updateItemMutation.isPending ? "Saving..." : "Save Changes";
  let t10;
  if ($[17] !== t9 || $[18] !== updateItemMutation.isPending) {
    t10 = <Button type="button" onClick={t8} disabled={updateItemMutation.isPending}>{t9}</Button>;
    $[17] = t9;
    $[18] = updateItemMutation.isPending;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7) {
    t11 = <DialogFooter className="mt-4">{t7}{t10}</DialogFooter>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t6) {
    t12 = <DialogContent className="sm:!max-w-2xl max-h-[90vh] flex flex-col">{t5}{t6}{t11}</DialogContent>;
    $[23] = t11;
    $[24] = t6;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isOpen || $[27] !== onClose || $[28] !== t12) {
    t13 = <Dialog open={isOpen} onOpenChange={onClose}>{t12}</Dialog>;
    $[26] = isOpen;
    $[27] = onClose;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp2(tag) {
  return tag.trim();
}
function _temp() {
  document.body.style.overflow = "";
  document.body.style.pointerEvents = "";
}